module.exports = __webpack_public_path__ + "static/media/8OLA5.2b7e8606.jpg";